// extracted by mini-css-extract-plugin
export var button = "_mc-2";
export var card = "_mc-0";
export var closeButtonContainer = "_mc-3";
export var iconContainer = "_mc-1";